<div fxLayout="row" class="container">
  <div fxFlex fxLayout="row" fxLayoutAlign="center top" class="summary-container">
    <div *ngIf="screenshotsMade">
      <app-summary fxFlex="100%" [readOnly]="false" [loading]="loading"></app-summary>
    </div>
    <div [class.visible]="!screenshotsMade" class="loading">
      <app-loading-indicator></app-loading-indicator>
      <div>{{ 'PLEASE_WAIT' | translate }}</div>
    </div>
  </div>
  <app-summary-price-list *ngIf="pricesVisible && screenshotsMade" [loading]="loading"></app-summary-price-list>
  <app-summary-share-demo *ngIf="!pricesVisible && screenshotsMade" [loading]="loading"></app-summary-share-demo>
</div>
<div class="close-container" (click)="gotoPreviousStep()">
  <div class="leftright"></div>
  <div class="rightleft"></div>
</div>
